export const ADD_EVENT = 'addEvent';
export const ADD_EVENTS = 'addEvents';
export const DELETE_EVENT = 'deleteEvent';
export const REPLACE_EVENT = 'replaceEvent';
export const SET_ATTENDING_STATE = 'setAttendingState';
export const RESET_ATTENDING_STATE = 'resetAttendingState';
